export var STATUS = {
    rejected: 'REJECTED',
    cancelled: 'CANCELED',
    posted: 'POSTED',
    pending: 'PENDING',
    scheduled: 'SCHEDULED',
    processing: 'PROCESSING'
};
export var TYPE = {
    autopay: 'AUTOPAYMENT',
    fee: 'FEE',
    payment: 'PAYMENT',
    purchase: 'PURCHASE',
    lateFee: 'LATE_FEE',
    refund: 'REFUND',
    interest: 'INTEREST',
    adjustment: 'ADJUSTMENT'
};
